<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content" v-if="open">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title" style="width:100%">
            <div class="d-flex justify-content-between">
              <div class="d-flex">{{ modal_title }} {{ bulletin_board_data.upd_nm }}</div>
              <div class="d-flex text-dark" style="font-size: 18px;line-height: 33px;">最後一次編輯時間：{{bulletin_board_data.upd_time | dateFormat }}</div>
            </div>
          </h3>
        </div>
        <div class="modal-body">
          <form class="form">
            <div v-if="isEdit === true">
              <div class="col-12">
                <h4 class="text-green m-0">發文注意事項：</h4>
              </div>
              <div class="col-12">
                <p>
                  1. 不得發布身分證字號、保單號碼及其他『足資識別該個人之資料』相關資訊。 <br />
                  2. 上傳之文件或影片等文件不得構成著作財產權之侵害。 <br />
                  3. 若有發現違法之情事，經查屬實後管理者得將違法者停權並送人資議處。 <br />
                </p>
              </div>
            </div>
            <table class="table table-basic mt-4 mb-4">
              <thead>
                <tr>
                  <th class="w-220">發文單位</th>
                  <td>{{ bulletin_board_data.dvnm }}</td>
                </tr>
                <tr>
                  <th class="w-220">申請者</th>
                  <td>{{ bulletin_board_data.emp_nm }}</td>
                </tr>
              </thead>
            </table>
            
            <table class="table table-basic mt-4 mb-4">
              <thead>
                <tr>
                  <th class="w-220">公告對象</th>
                  <td>{{ announcementObject }}</td>
                </tr>
                <tr>
                   <th class="w-220">主旨<br /><small style="color:black;">最多20個字元(10個中文字)</small></th>
                  <td>{{ bulletin_board_data.subject }}</td>
                </tr>
                <tr>
                  <th class="w-220">內文<br /><small style="color:black;">(最多100個中文字)</small></th>
                  <td v-if="isEdit === false">
                    {{ bulletin_board_data.words }}
                  </td>
                  <td v-else>
                    <textarea v-model="bulletin_board_data.words" class="form-control" rows="6" maxlength="400">
                    </textarea>
                    <div v-if="contentDisabled" class="d-flex align-items-center text-danger ml-2">已超過最大字數</div>
                  </td>
                </tr>
                <tr>
                  <th class="w-220">連結方式</th>
                  <td>
                    <div class="radio radio-inline" v-for="(single, index) in link" :key="`bulletin-link-${index}`">
                      <input disabled type="radio" :id="`bulletin-link-${index}`" name="bulletin-link" :value="single.value" v-model="bulletin_board_data.link_way">
                      <label :for="`bulletin-link-${index}`">{{ single.name }}</label>
                    </div>
                  </td>
                </tr>
                <tr>
                   <th class="w-220">發佈日期</th>
                  <td >
                    {{startDate | dateFormat }}
                  </td>
                </tr>
                <tr>
                  <th class="w-220">下架日期</th>
                  <td v-if="isEdit === false">
                    {{ bulletin_board_data.end_date | dateFormat}}
                  </td>
                  <td v-else class="d-flex">
                    <date-picker
                      v-model="endDate"
                      :format="dateFormatter"
                      :language="dateLang"
                      :first-day-of-week="1" />
                      <div class="d-flex align-items-center" style="margin-left: 1rem;font-size: 22px;color:#F58818">
                        <i class="icon-calendar"  /> <span style="font-size:15px">（上架期間不得超過兩週）</span>
                      </div>
                  </td>
                </tr>
              </thead>
            </table>

            <table class="table table-basic mt-4 mb-4">
              <thead>
                <tr v-if="bulletin_board_data.link_way == '1'">
                  <th class="w-220">網頁連結</th>
                  <td class="card-text-format">{{ bulletin_board_data.http }}</td>
                </tr>
                <tr v-if="bulletin_board_data.link_way == '2'">
                  <th class="w-220">檔案名稱</th>
                  <td>
                    <a @click.prevent="download(bulletin_board_data.ser_no, bulletin_board_data.filename)" 
                    class="pointer-cursor text-underline text-green">
                      {{ bulletin_board_data.filename }}
                    </a>
                  </td>
                </tr>
              </thead>
            </table>

            <div class="action text-right" v-if="isEdit">
              <a v-if="typeStatus == '1'" @click="takeoffCondition" class="btn btn-default">
                直接下架
              </a>
              <a @click.stop.prevent="changeCondition()"  :disabled="contentDisabled" class="btn btn-primary">
                修改完成
              </a>
            </div>
            
          </form>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import  {mapGetters} from 'vuex'
import DatePicker from '@/components/DatePicker/components/Datepicker'
import {commonMixin} from '@/mixins/common'
import {modifyNews, downNews, downloadFile} from '@/service'
import {en, zh} from '@/components/DatePicker/locale'
import { saveAs } from 'file-saver'

export default {
  // name: 'ConditionalCombinationModal',
  name:'BulletinBoardModal',
  components: {DatePicker},
  mixins: [commonMixin],
  props: {
    isEdit: {
      type: Boolean
    },
    open: {
      type: Boolean,
      default: false
    },
    bulletin_board_data: {
      type: Object,
      default: null
    },
    modal_title: {
      type: String,
      default: ''
    },
    typeStatus: {
      type: String,
      default: '1'
    },
  },
  computed: {
    ...mapGetters(['UserInfo']),
  },  
  watch:{
    open (val) {
      if(val){
        this.startDate = this.bulletin_board_data.star_date
        let endDate = this.bulletin_board_data.end_date.split('-')
        this.endDate  = `${endDate[0] - 1911}/${(endDate[1].length==1 ? `0${endDate[1]}` : '') + endDate[1]}/${(endDate[2].length==1 ? `0${endDate[2]}` : '') + endDate[2]}`;
        this.registerHanlink() // for 難字
      }
    },
    'bulletin_board_data.words': {
      handler: function(val) {
        if(val.length > 100) {
          this.contentDisabled = true;
        }else{
          this.contentDisabled = false;
        }
      },
    },
  },
  data () {
    return {
      //Datepicker
      dateLang: zh,
      startDate:'',
      endDate:'',
      announcementObject:'',
      dateFormatter: (date) => {
        const m = date.getMonth() + 1
        const d = date.getDate()
        return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
      },
      link: [
        {
          'name': '無連結',
          'value': '0'
        },
        {
          'name': '網頁連結',
          'value': '1'
        },
        {
          'name': '檔案附件',
          'value': '2'
        }
      ],
      contentDisabled: false,
    }
  },
  methods: {
    saveAsDownload (url, name) {
      const vm = this
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.responseType = 'blob';

      xhr.onload = function () {
        vm.doSaveAs(xhr.response, name)
      };

      xhr.onerror = function () {
        console.error('could not download file');
      };

      xhr.send();
    },
    doSaveAs (result, filename) {
      saveAs(result, filename)
      
      // 測試 Pad 另開分頁無效果 目前狀況 無解
      // const testRegex = /iPad/i
      // const is_iPad = testRegex.test(navigator.userAgent) // 確認裝置是否為 iPad
      // if (is_iPad) {
      //   if (typeof result === 'string') return this.saveAsDownload (result, filename);
      //   let URL = window.URL || window.webkitURL;
      //   let url = URL.createObjectURL(result);
      //   popup = open('', '_blank')
      //   popup.document.title = popup.document.body.innerText = 'downloading...'
      //   popup.location.href = url
      //   popup = null; // reverse-tabnabbing #460
      //   setTimeout(function () {
      //     URL.revokeObjectURL(url);
      //   }, 4E4); // 40s
      // } else {  // 如果不是 iPad 使用 file-saver 套件
      //   saveAs(result, filename)
      // }
    },    
    download (ser_no, filename) {
      const vm = this
      downloadFile(this.$store.state.userInfo.id, ser_no, filename).then(result => {
        if (result.type == 'application/json') {  // application/json 為檔案下載失敗
          //  把回傳的 blob 轉為 文字檔後再用 json parse
          let reader = new FileReader()
          reader.onload = function () {
            let unicodeJsonA = JSON.parse(reader.result)
            if(unicodeJsonA.header.message) {
              vm.setToastMsg(unicodeJsonA.header.message)
            } else {
              vm.setToastMsg('伺服器連線異常')
            }
          }
          reader.readAsText(result)
        } else {
          //  成功取得檔案  進行下載
          this.doSaveAs(result, filename)
        }
      })
    },
    dataCheck () { 
      // 計算 發佈 下架 相差天數
      
      const dateRange = this.mixDateDiff(null ,this.endDate)
      if(this.typeStatus =="1"){ //發佈中卡控 預發佈：下架日期卡發佈日+2周,已下架：下架日期卡系統日+2周 

        if(this.mixDateDiff(null ,this.startDate)  > 0  ){ // 預發佈  
            if(dateRange < 0 || dateRange > 14) {
              this.setToastMsg('「預發佈時間」距離「下架時間」最多2週')
              return false
            }
        }else{ //發佈中或已下架
          const afterDateRange = this.mixDateDiff(this.startDate,this.endDate)
          if(afterDateRange < 0 || afterDateRange > 14) {
            this.setToastMsg('「當前時間」距離「下架時間」最多2週')
            return false
          }       
        }
      }else{ //已下架卡控 發佈中：下架日期卡發佈日+2周,已下架：下架日期卡系統日+2周 
          const nowEndDate = this.mixDateDiff(null,this.endDate)
          if(nowEndDate < 0) {
              this.setToastMsg('「原下架時間」不得小於「下架時間」')
              return false
          }else if(nowEndDate > 14){
              this.setToastMsg('「當前時間」距離「下架時間」最多2週')
              return false
          }
      }
          return true
    },  
    fmDate (date) {  // 轉換 Date 物件為 'YYYY-MM-DD' string
      let nowDateY = date.getYear().toString().replace(/^./,'20')
      let nowDateM = (date.getMonth() + 1).toString().length == 1 ? `0${(date.getMonth() + 1).toString()}` : (date.getMonth() + 1).toString()
      let nowDateD = date.getDate().toString().length == 1 ? `0${date.getDate().toString()}` : date.getDate().toString()
      return `${nowDateY}-${nowDateM}-${nowDateD}`
    },        
    fmAdDate(date){ //民國轉換西元格式
      let adDate = date.split('/') 
      return parseInt(adDate[0])+1911+'-'+adDate[1]+'-'+adDate[2]  
    },
    dateFormat: (date) => {
      date = new Date(date)
      const m = date.getMonth() + 1
      const d = date.getDate()
      return `${date.getFullYear() - 1911}/${(m < 10 ? '0' : '') + m}/${(d < 10 ? '0' : '') + d}`;
    },
    takeoffCondition() {
      let form = {
        ser_no: this.bulletin_board_data.ser_no,  
        end_date: this.bulletin_board_data.end_date,
        upd_id: this.UserInfo.id,
        upd_nm: this.UserInfo.name,
      }
      downNews(this.UserInfo.id, form).then(result => {
        if(result.header && result.header.status == '200'){
          this.setToastMsg("已下架一則消息")
          this.$emit('refresh')
          this.$emit('close')
        }else{
          this.setToastMsg(result.header.message)
        }
      })
    },
    changeCondition(){ //修改功能
      if(this.dataCheck()){
          let form ={}
        if(typeof this.endDate == 'string'){
            form.end_date = this.fmAdDate(this.endDate) //民國轉換西元格式
        }else{
            form.end_date = this.fmDate(this.endDate)  //Date轉換西元格式
        }
            form.ser_no = this.bulletin_board_data.ser_no
            form.upd_id = this.bulletin_board_data.upd_id
            form.upd_nm = this.bulletin_board_data.upd_nm
            form.words = this.bulletin_board_data.words
        modifyNews(this.UserInfo.id, form).then(result => {
          if(result.header && result.header.status == '200'){
            this.setToastMsg(result.header.message)
            this.$emit('refresh')
            this.$emit('close')
            this.$router.push({path:`/manager/BulletinBoard/tab/1`})
          }else{
            this.setToastMsg(result.header.message)
          }
        })
      }
    },  
    initial(){
       if(this.UserInfo.roleId.includes('01')){

         this.announcementObject  = '單位所有人'
       }else{
         this.announcementObject  = '轄下所有單位'
       }
 
    }

  },
  mounted () {
      this.initial()
      $('span').blur();
  }
}
</script>
<style>
.card-text-format {
  word-wrap:break-word;
  word-break:break-all;
}
</style>